import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/index.css';
import { getSession } from './lib/session';

// Warm the guest session in the background; screens await it only when needed.
void getSession().catch(() => {
  /* Offline / worker not running — API calls will surface errors in-context. */
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
